export const keepScroll = {
  beforeRouteLeave (to, from, next) {
    this.$store.commit('device/SET_PAGE_SCROLL', {
      pageName: from.name,
      scroll: window.scrollY
    })

    next()
  },
  mounted() {
    scroll(0, this.$store.getters["device/scroll"][this.$route.name] || 0)
  }
}
